import { Chip, Icon } from '@mui/material';
import { convertConstantLiteralToNormal } from '../../utils/string.helpers';
import {
  HourglassEmptyRounded,
  Refresh,
  CheckCircle,
  AssignmentTurnedIn,
  // WarningSharp,
  Sync,
  SyncDisabled,
  AssignmentReturn,
} from '@material-ui/icons';

export default function StatusChip({ status, small }: { status: string; small?: boolean }) {
  {
    let color = 'default';
    let variant = 'filled';
    let icon: any;
    switch (status) {
      case 'NEW':
      case 'PENDING':
        color = 'default';
        icon = <HourglassEmptyRounded />;
        break;
      case 'PROCESSING':
        color = 'default';
        icon = <Refresh />;
        break;
      case 'PENDING_APPROVAL':
        color = 'warning';
        icon = <CheckCircle />;
        break;
      case 'APPROVED':
        color = 'info';
        icon = <AssignmentTurnedIn />;
        break;
      case 'REJECTED':
        color = 'error';
        icon = <AssignmentReturn />;
        break;
      case 'SYNCING':
        variant = 'outlined';
        color = 'success';
        icon = <Sync className="spin-left slow" />;
        break;
      case 'SYNCED':
        color = 'success';
        icon = <CheckCircle />;
        break;
      case 'SYNC_FAILED':
        color = 'error';
        icon = <SyncDisabled />;
        break;
      case 'PARTIALLY_SYNCED':
        color = 'warning';
        icon = <SyncDisabled />;
    }

    const humanizedStatus = convertConstantLiteralToNormal(status);
    if (small) {
      return (
        <Icon color={color as any} style={{ height: 24 }} title={humanizedStatus}>
          {icon}
        </Icon>
      );
    }
    return (
      <Chip
        icon={icon}
        size="small"
        variant={variant as any}
        label={small ? '' : humanizedStatus}
        color={color as any}
      />
    );
  }
}
